/*
 * @Descripttion: 角色常量
 * @version:
 * @Author: gjqiang
 * @Date: 2021-5-7 10:17:41
 */

export const DEALER_FRONTEND = 8 // 经销商
export const SALESMAN = 6 // 业务员
export const ADMINISTRATOR = 7 // 管理员
export const DEALER = 3 // 经销商
export const DESIGNER = 9 // 设计师
